import { KnockProvider, KnockFeedProvider } from "@knocklabs/react";
import "@knocklabs/react/dist/index.css";
import { useKnockToken } from "@/hooks/useKnockToken";
import { KnockCacheInvalidator } from "./KnockCacheInvalidator";

const KNOCK_PUBLIC_KEY = import.meta.env.VITE_KNOCK_PUBLIC_API_KEY;
const KNOCK_FEED_CHANNEL_ID = import.meta.env.VITE_KNOCK_FEED_CHANNEL_ID;

export function KnockNotificationProvider({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const { data: knockAuth } = useKnockToken();

  // Don't render Knock provider until we have auth + token + config
  if (!knockAuth || !KNOCK_PUBLIC_KEY || !KNOCK_FEED_CHANNEL_ID) {
    return <>{children}</>;
  }

  return (
    <KnockProvider
      apiKey={KNOCK_PUBLIC_KEY}
      userId={knockAuth.userId}
      userToken={knockAuth.token}
    >
      <KnockFeedProvider feedId={KNOCK_FEED_CHANNEL_ID}>
        <KnockCacheInvalidator />
        {children}
      </KnockFeedProvider>
    </KnockProvider>
  );
}
